import { useCallback, useMemo } from "react";
import { Button, Table } from "@mantine/core";
import { IconArrowUp, IconArrowDown } from "@tabler/icons-react";
import type { QueueSortState } from "../../pages/workflows/pathologistReviewQueueView";
import type { QueueColumnDef } from "../../pages/workflows/queueColumnConfig";

interface Props {
  column: QueueColumnDef;
  sorts: QueueSortState[];
  onSort: (column: string) => void;
}
export function PendingWorkColumnHeader({ column, sorts, onSort }: Props) {
  const index = useMemo(
    () => sorts.findIndex((sort) => sort.column === column.id),
    [column.id, sorts]
  );
  const sort = useMemo(() => sorts[index], [index, sorts]);
  const handleSort = useCallback(() => onSort(column.id), [column.id, onSort]);
  return (
    <Table.Th
      style={{ minWidth: column.width }}
      aria-sort={
        index === 0
          ? sort.direction === "asc"
            ? "ascending"
            : "descending"
          : "none"
      }
    >
      <Button
        variant="subtle"
        color="dark"
        size="compact-xs"
        onClick={handleSort}
        aria-label={`Sort ${column.label}${
          sort ? `, priority ${index + 1}, ${sort.direction}` : ""
        }`}
      >
        {column.label}{" "}
        {sort && (
          <>
            {sort.direction === "asc" ? (
              <IconArrowUp size={13} />
            ) : (
              <IconArrowDown size={13} />
            )}{" "}
            {index + 1}
          </>
        )}
      </Button>
    </Table.Th>
  );
}
